module.exports = __webpack_public_path__ + "img/guide3.15dc86ab.png";